import React from "react";

const CardShimmer = ({ size = 10 }) => {
    return (
        <div className="store-preview-shimmer">
            <div className="custom-container">
                <div className="row">
                    {new Array(size).fill({}).map((a, index) => (<div className="col-md-3">
                        <div className="shimmer product-shimmer">
                            <div className="wrappercard">
                                <div className="image-card animate"></div>
                                <div className="shimmercontant">
                                    <div className="stroke animate title1"></div>
                                    <div className="stroke animate title2"></div>
                                </div>
                            </div>
                        </div>
                    </div>))}
                </div>
            </div>
        </div>
    )
}

export default CardShimmer;